var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.876 1.48l10.915 19.844a1 1 0 01-.771 1.637H1a1 1 0 01-.876-1.482l11-20c.35-.639 1.401-.639 1.752 0zM12 4.035L2.691 20.961h18.617L12 4.036zm.712 13.215c.18.19.29.45.29.71a1.009 1.009 0 01-1 1c-.27 0-.52-.11-.71-.29-.19-.19-.29-.45-.29-.71 0-.26.1-.52.29-.71.37-.37 1.05-.37 1.42 0zM12 8.961a1 1 0 011 1v5a1 1 0 01-2 0v-5a1 1 0 011-1z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconWarning;